module.exports = __webpack_public_path__ + "static/media/placeholder.1b48397f.png";